import type { PolymorphicProps } from '@kobalte/core/polymorphic'
import type { PopoverContentProps, PopoverRootProps } from '@kobalte/core/popover'
import type { ComponentProps, ParentProps, ValidComponent } from 'solid-js'
import { Popover as PopoverPrimitive } from '@kobalte/core/popover'
import { mergeProps, splitProps } from 'solid-js'
import { cn } from '../../utils/cn.ts'
import { Button } from './Button.tsx'

export const PopoverTrigger = PopoverPrimitive.Trigger
export const PopoverTitle = PopoverPrimitive.Title
export const PopoverDescription = PopoverPrimitive.Description

export function Popover(props: PopoverRootProps) {
  const merge = mergeProps<PopoverRootProps[]>(
    {
      gutter: 4,
      flip: false,
    },
    props,
  )

  return <PopoverPrimitive {...merge} />
}

type popoverContentProps<T extends ValidComponent = 'div'> = ParentProps<
  PopoverContentProps<T> & {
    class?: string
  }
>

export function PopoverContent<T extends ValidComponent = 'div'>(props: PolymorphicProps<T, popoverContentProps<T>>) {
  const [local, rest] = splitProps(props as popoverContentProps, ['class', 'children'])

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        class={cn(
          'z-50 w-72 rounded-xl border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[expanded]:(animate-in fade-in-0 zoom-in-95) data-[closed]:(animate-out fade-out-0 zoom-out-95)',
          local.class,
        )}
        {...rest}
      >
        {local.children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  )
}

export function PopoverCloseButton(props: ComponentProps<typeof PopoverPrimitive.CloseButton>) {
  return (
    <PopoverPrimitive.CloseButton
      as={props => (
        <Button variant="ghost" size="icon" {...props} class={cn('size-6 shrink-0', props.class)}>
          <div class="i-lucide-x size-4" />
        </Button>
      )}
      {...props}
    />
  )
}
